/* global google */
// Utility class for fetching and caching directions from station to incident
// location. Caching was put in place to reduce the number of calls to the
// (billed) Google Directions API. In addition, when switching between
// incidents, it should only fetch directions once per incident.
class GoogleDirectionAPIWrapper {
  constructor() {
    this.directionsCache = {};
    this.directionsService = new google.maps.DirectionsService();
  }

  fetch(origin, destination) {
    return new Promise((resolve, reject) => {
      if (!origin || !destination) return resolve(null);
      if (origin.lat === destination.lat && origin.lng == destination.lng) {
        // if origin and destination are the same, rendering directions on the
        // map causes the zoom level to get messed up. This is extremely
        // unlikely to happen, but this caused a lot of research to find out
        // what was going on. Better to return no directions at all.
        return resolve(null);
      }

      // create a cache key based on the coords of the origin and destination
      const cacheKey = JSON.stringify({ origin, destination });
      // check cache and return previously obtained result from Google
      // Directions API if available
      const cachedResult = this.directionsCache[cacheKey];
      if (cachedResult) return resolve(cachedResult);

      this.directionsService.route(
        {
          origin: new google.maps.LatLng(origin),
          destination: new google.maps.LatLng(destination),
          travelMode: google.maps.TravelMode.DRIVING
        },
        (result, status) => {
          if (status === google.maps.DirectionsStatus.OK) {
            this.directionsCache[cacheKey] = result;
            resolve(result);
          } else {
            console.error(`error fetching directions`, result);
            reject(status);
          }
        }
      );
    });
  }
}

let instance = null;

GoogleDirectionAPIWrapper.getInstance = () => {
  instance = instance || new GoogleDirectionAPIWrapper();
  return instance;
};

export default GoogleDirectionAPIWrapper;
